var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-12"},[_vm._v(" Link yang kamu punya tidak valid atau pendaftaran sudah ditutup ")])}
var staticRenderFns = []

export { render, staticRenderFns }